export default __webpack_public_path__ + "static/media/Share.5322c3b7.svg";